import React, { Component,useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter, Route, Switch } from "react-router-dom";
import HomeV1 from './components/home-v1';
import Diamantine from './components/Diamantine';
import Ezzahara from './components/Ezzahara';
import ScrollToTop from './ScrollToTop';
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';


class Root extends Component {
    
    render() 
    {
        return(
                <BrowserRouter basename="/">
                          <ScrollToTop />

	                    <Route exact path="/" component={HomeV1} />
	                    <Route exact path="/Diamantine" component={Diamantine} />
	                    <Route exact path="/Ezzahara" component={Ezzahara} />
                </BrowserRouter>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('quarter'));
